import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoraChannelPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_131_23162)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.5 0.0170898H3.5C3.10218 0.0170898 2.72064 0.175125 2.43934 0.45643C2.15804 0.737734 2 1.11927 2 1.51709V10.4831C2 10.8809 2.15804 11.2624 2.43934 11.5437C2.72064 11.8251 3.10218 11.9831 3.5 11.9831H8.5C8.89782 11.9831 9.27936 11.8251 9.56066 11.5437C9.84196 11.2624 10 10.8809 10 10.4831V1.51709C10 1.11927 9.84196 0.737734 9.56066 0.45643C9.27936 0.175125 8.89782 0.0170898 8.5 0.0170898ZM6 11.2331C5.90111 11.2331 5.80444 11.2038 5.72221 11.1488C5.63999 11.0939 5.5759 11.0158 5.53806 10.9244C5.50022 10.8331 5.49031 10.7325 5.50961 10.6355C5.5289 10.5386 5.57652 10.4495 5.64645 10.3795C5.71637 10.3096 5.80546 10.262 5.90245 10.2427C5.99945 10.2234 6.09998 10.2333 6.19134 10.2711C6.2827 10.309 6.36079 10.3731 6.41573 10.4553C6.47068 10.5375 6.5 10.6342 6.5 10.7331C6.5 10.8657 6.44732 10.9929 6.35355 11.0866C6.25979 11.1804 6.13261 11.2331 6 11.2331ZM9 8.98309C9 9.1157 8.94732 9.24288 8.85355 9.33664C8.75979 9.43041 8.63261 9.48309 8.5 9.48309H3.5C3.36739 9.48309 3.24021 9.43041 3.14645 9.33664C3.05268 9.24288 3 9.1157 3 8.98309V1.76709C3 1.63448 3.05268 1.5073 3.14645 1.41354C3.24021 1.31977 3.36739 1.26709 3.5 1.26709H8.5C8.63261 1.26709 8.75979 1.31977 8.85355 1.41354C8.94732 1.5073 9 1.63448 9 1.76709V8.98309Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_131_23162",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgNoraChannelPhone;
